module.exports = __webpack_public_path__ + "static/media/Workstation.e0b93bf0.svg";